import script from "./ShowAllPaymentSmall.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowAllPaymentSmall.vue?vue&type=script&setup=true&lang=js"

import "./ShowAllPaymentSmall.vue?vue&type=style&index=0&id=22094c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22094c80"]])

export default __exports__